import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import { PageLayout } from "../../../layouts/PageLayout";
import { CardLayout, PageHeader } from "../../../components/v3";
import { get_date } from "../../../components/generalComponets";
import { resolveNotificationPath, getSeverityBorder } from "../../../features/notifications/notification.utils";
import {
  fetchNotifications as fetchNotificationsThunk,
  markAsRead as markAsReadThunk,
  markAllAsRead as markAllAsReadThunk,
} from "../../../reducers/notification";

export const ViewAllNotification = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { items: notification, unreadCount: notificationCount, loading } = useSelector((state) => state.notifications);

  useEffect(() => {
    dispatch(fetchNotificationsThunk());
  }, [dispatch]);

  const handleRefresh = () => {
    dispatch(fetchNotificationsThunk());
  };

  const markOneAsRead = (item) => {
    if (item?.isRead) return;
    dispatch(markAsReadThunk(item.id));
  };

  const markAllAsRead = () => {
    dispatch(markAllAsReadThunk());
  };

  const handleSingleNotification = (item) => {
    if (!item?.isRead) {
      markOneAsRead(item);
    }

    const path = resolveNotificationPath(item?.data);
    if (path) {
      navigate(path);
    }
  };

  return (
    <>
      <PageLayout>
        <PageHeader
          title="Notification"
          subtitle={notificationCount > 0 ? `${notificationCount} unread notifications` : "No unread notifications"}
          buttons={[
            {
              buttonText: "Mark all as read",
              buttonIcon: () => (
                <i className="material-icons" style={{ fontSize: 18 }}>
                  done_all
                </i>
              ),
              onClick: markAllAsRead,
              disabled: loading || notificationCount === 0,
            },
            {
              buttonText: "Refresh",
              buttonIcon: () => (
                <i className="material-icons" style={{ fontSize: 18 }}>
                  refresh
                </i>
              ),
              onClick: handleRefresh,
              disabled: loading,
            },
          ]}
        />

        <Box sx={{ mt: -9, position: "relative", zIndex: 2 }}>
          <CardLayout>
            {loading && notification.length === 0 ? (
              <Typography variant="body2" sx={{ py: 4, textAlign: "center", color: "text.secondary" }}>
                Loading notifications...
              </Typography>
            ) : notification.length === 0 ? (
              <Typography variant="body2" sx={{ py: 4, textAlign: "center", color: "text.secondary" }}>
                No notifications to show.
              </Typography>
            ) : (
              notification.map((item) => (
                <Box key={item.id} sx={{ mb: 1.5 }}>
                  <Box
                    onClick={() => handleSingleNotification(item)}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      p: 2,
                      borderRadius: 1.5,
                      cursor: "pointer",
                      border: "1px solid",
                      borderColor: "rgba(0, 0, 0, 0.06)",
                      borderLeft: "4px solid",
                      borderLeftColor: getSeverityBorder(item.severity),
                      bgcolor: item.isRead ? "#fff" : "rgba(103, 75, 245, 0.04)",
                      "&:hover": { bgcolor: "rgba(0, 0, 0, 0.04)" },
                      transition: "background-color 0.15s",
                    }}
                  >
                    <Box sx={{ flex: 1, position: "relative" }}>
                      <Typography variant="body2" sx={{ fontWeight: item.isRead ? 400 : 600, pr: 3 }}>
                        {item.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "text.secondary", mt: 0.25 }}
                        dangerouslySetInnerHTML={{ __html: item.body }}
                      />
                      <Typography variant="caption" sx={{ color: "text.disabled", mt: 0.5, display: "block" }}>
                        {get_date(item.createdAt)}
                      </Typography>
                      {!item.isRead && (
                        <Box
                          sx={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            bgcolor: "#674BF5",
                            position: "absolute",
                            top: 0,
                            right: 0,
                          }}
                        />
                      )}
                    </Box>
                  </Box>
                </Box>
              ))
            )}
          </CardLayout>
        </Box>
      </PageLayout>
    </>
  );
};
